export default __webpack_public_path__ + "scripts/resource/034274e692364e4f6856459bece6d90f.svg";